import SidebarItemIcon from '@/components/SidebarItemIcon/SidebarItemIcon';

export default SidebarItemIcon;
